<template>
    <v-expansion-panel class="elevation-0 bordered-filter" v-model="expand" expand>
        <v-expansion-panel-content expand-icon="keyboard_arrow_right" class="transparent">
            <template v-slot:header>
                <v-layout row wrap align-center ma-0>
                    <v-flex xs2>
                        <v-img :src="iconPath"/>
                    </v-flex>
                    <v-flex xs10 class="categories-filter-title">
                        <div class="body-2">{{ 'Category' | translation }}</div>
                    </v-flex>
                </v-layout>
            </template>

            <template v-if="parentsList && parentsList.length > 0">
                <template v-for="(parent, i) in parentsList">
                    <v-btn
                        block
                        class="category-button"
                        @click="applyCategory(parent.value)"
                        flat
                        :key="1"
                    >
                        <v-icon>keyboard_arrow_left</v-icon>
                        {{parent.label}}
                    </v-btn>
                </template>
            </template>

            <v-treeview
                class="category-filter"
                v-if="categories.length"
                :items="categories"
                item-key="value"
                item-children="childrenData"
                :open-all="true"
                ref="categoriesTree"
                :activatable="!loading"
                :hoverable="!loading && hoverable"
                :active.sync="active"
                expand-icon=""
                :key="JSON.stringify(categories)"
            >
                <template v-slot:prepend="{ item }">
                    <v-icon v-if="isChild(item)">arrow_right</v-icon>
                </template>
                <template v-slot:label="{ item }">
                    <span class="mr-1 category-filter-name">{{ item.label }}</span>
                    <span class="category-filter-products-amount">({{ categoriesFacet[item.value] }})</span>
                </template>
            </v-treeview>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<style>
    .category-button {
        font-size: 16px;
        font-weight: 400;
        padding-left: 0;
        text-transform: none;
    }

    .category-button .v-btn__content {
        justify-content: left;
    }

    .category-filter .v-treeview-node__root {
        cursor: pointer;
    }

    .category-filter .v-treeview-node__toggle {
        pointer-events: none;
    }

    .category-filter .v-treeview-node__label {
        font-size: 16px;
    }

    .category-filter .v-treeview-node .v-treeview-node--leaf {
        margin-left: 0 !important;
    }

    .category-filter .v-treeview-node--active {
        background: transparent !important;
        font-weight: 700;
    }

    .category-filter.v-treeview > .v-treeview-node--leaf {
        margin-left: 0 !important;
    }
</style>

<script>
    import {mapGetters, mapState} from 'vuex';
    import SearchResults from './SearchResults';
    const searchFiltersModuleName = 'SearchFilters';

    export default {
        name: 'CategoriesFilter',
        props: {
            parentsList: {},
            categories: {},
            categoriesFacet: {},
            value: {},
            expanded: Boolean,
            hoverable: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                active: [],
                expand: [Boolean(this.$router.currentRoute.params.category) || this.expanded || false],
            };
        },
        computed: {
            ...mapState(SearchResults.name, [
                'lastSearchParams',
                'loading',
            ]),
            ...mapState(searchFiltersModuleName, {
                allCategories: state => state.categories,
            }),
            ...mapGetters(SearchResults.name, [
                'searchConfig',
            ]),
            activeCategory() {
                return this.lastSearchParams.category;
            },
            iconPath() {
                return this.searchConfig('categorySearchFilterIconPath');
            },
        },
        methods: {
            isChild(item) {
                let isChild = false;
                this.categories.some(category => {
                    if (category.children.includes(item.value)) {
                        isChild = true;
                    }
                    return isChild;
                });
                return isChild;
            },
            applyCategory: function (categoryId) {
                if (!this.loading && this.$router.currentRoute && this.$router.currentRoute.params['category'] != categoryId) {
                    const path = this.$search.getSearchRouteParams({category: categoryId});
                    this.$router.push({
                        path: path === '/search/' ? '/search/q' : path
                    });
                }
            },
        },
        watch: {
            activeCategory: {
                immediate: true,
                handler: function (value) {
                    if (value) {
                        this.active = [value];
                    } else {
                        this.active = [];
                    }
                    this.$emit('input', this.allCategories && this.allCategories[value] ? this.allCategories[value].label : null);
                },
            },
            active(value) {
                if (value.length) {
                    this.applyCategory(value[0]);
                }
            },
            categories(value) {
                this.$nextTick(function () {
                    if (this.$refs['categoriesTree']) {
                        this.$refs['categoriesTree'].updateAll(true);
                    }
                });
            },
        },
    }
</script>
